import { UserManager as OIDCUserManager } from "oidc-client";
export const signInCallback = () => {
    return new OIDCUserManager({
        response_mode: "query", // https://github.com/IdentityModel/oidc-client-js/issues/780#issuecomment-470935675
    }).signinCallback(new URLSearchParams(location.search).toString());
};
export const signOutCallback = () => {
    return new OIDCUserManager({
        response_mode: "query", // https://github.com/IdentityModel/oidc-client-js/issues/780#issuecomment-470935675
    }).signoutCallback();
};
export const silentRenewCallback = () => {
    return new OIDCUserManager({
        response_mode: "query", // https://github.com/IdentityModel/oidc-client-js/issues/780#issuecomment-470935675
    }).signinSilentCallback();
};
export class AuthenticationCallbacks {
    constructor(userManager) {
        this.userManager = new OIDCUserManager({
            response_mode: "query", // https://github.com/IdentityModel/oidc-client-js/issues/780#issuecomment-470935675
        });
        this.signInCallback = () => {
            return this.userManager.signinCallback(new URLSearchParams(location.search).toString());
        };
        this.signOutCallback = () => {
            return this.userManager.signoutCallback();
        };
        this.silentRenewCallback = () => {
            return this.userManager.signinSilentCallback();
        };
        if (userManager) {
            this.userManager = new OIDCUserManager(Object.assign(Object.assign({}, userManager._settings), { response_mode: "query" }));
        }
    }
    signInRedirectCallback(url = new URLSearchParams(location.search).toString()) {
        return this.userManager.signinRedirectCallback(url);
    }
}
//# sourceMappingURL=authentication-callbacks.js.map